import { useEffect } from "react";

/** Shorthand for calling just once onMount and onUnmount
 * Same examples:
 * @example Shortest
 *    useOnce(startWorker, stopWorker);
 * @example Explicit
 * useOnce(() => {
 *  startWorker();
 *  return stopWorker;
 * });
 * @example Full syntax
 * useEffect(() => {
 *  startWorker();
 *  return stopWorker;
 * }, []);
 *
 * */
export default function useOnce(onMount, onUnmount) {
	useEffect(() => {
		const ret = onMount();
		return onUnmount || ret ? () => {
			if (onUnmount) onUnmount();
			if (ret && typeof ret === "function") ret();
		} : undefined;
	}, []);
}
